import gql from "graphql-tag";

export default gql`
  query MarketCapitalizationHistory($tickerSymbols: [TickerSymbol!]!) {
    marketCapitalizationHistoryByTickerSymbols(tickerSymbols: $tickerSymbols) {
      tickerSymbol
      nodes {
        totalCapitalization
        enterpriseValue
        asOfDate
        exchangeId
        tickerSymbol
      }
    }
  }
`;
